export default __webpack_public_path__ + "static/media/companies.2130f069.png";